export function buildMachineryDirectiveStudioBaseHref(
  productId: string,
  machineryDirectiveComplianceId: string
): string {
  return `/product-catalog/${productId}/machinery-directive/${machineryDirectiveComplianceId}`
}
